export default __webpack_public_path__ + "assets/images/a9fb419324d4b0df2b7016fa32f3a645.png";